import React, {useEffect} from "react";
import {getCategory} from "../../../static/js/service/shopService";

export default function ShopCategoryV2({shopId}) {
  useEffect(() => {
    getCategory(shopId).then((response) => {
      document.getElementById(`category${shopId}`).innerText = response.map((item) => item.categoryName).join(', ');
    });
  }, [shopId]);

  return (
    <p id={`category${shopId}`}></p>
  )
}